import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { OdsServices } from '../../services';
import { TakeawayServices } from '../../../takeaway/services';
import * as firebase from 'firebase';
import { OdsConfigMenuCreatePage } from './ods-config-menu-create/ods-config-menu-create';

/**
 * Generated class for the OdsListViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-config-menu',
    templateUrl: 'ods-config-menu.html',
})
export class OdsConfigMenuPage {
    firestore: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public translate: TranslateService,
        public globals: Globals,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public takeawayServices: TakeawayServices) {
        this.firestore = firebase.firestore();
        if (!this.odsServices.carta_takeaway.UID) {
            this.createTkMenu();
        }
    }

    createTkMenu() {
        let tk_menu = {
            UID_RESTAURANT: this.globals.restaurant_uid,
            name: this.translate.instant('general-titulo-carta'),
            name_ca: this.translate.instant('general-titulo-carta'),
            name_en: this.translate.instant('general-titulo-carta'),
            name_it: this.translate.instant('general-titulo-carta'),
            name_fr: this.translate.instant('general-titulo-carta'),
            name_de: this.translate.instant('general-titulo-carta'),
            subtitle: '',
            template_name: 'typhoon',
            created_at: new Date(),
            show_enumerate_elements: false,
            show_logo: true,
            show_caption: false,
            hide_footer: true,
            show_description: false,
            show_price: true,
            show_price_half: true,
            show_price_tapa: true,
            show_enumerate_pages: false,
            template: 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates%2Ffons_mct_blanc.png?alt=media&token=15455e42-1097-4eb0-bb47-1d29ef9622d5',
            digital_app: false,
            order_share: 0,
            pages: [{
                number: 0,
                sections: []
            }],
            tk_active: true
        };
        this.odsServices.afs.collection('cartas').add(tk_menu).then(doc => {
            tk_menu['UID'] = doc.id;
        });
        this.odsServices.carta_takeaway = tk_menu;
    }

    next() {
        if (!this.odsServices.takeaway_config.config_menu) {
            this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/takeaway').doc('config').update({
                config_menu: true
            });
            this.odsServices.takeaway_config.config_menu = true;
            this.navCtrl.push(OdsConfigMenuCreatePage);
        } else {
            this.navCtrl.pop();
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-menu/ods-config-menu.ts